import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { useMemo } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';

const ProfileAddress_1 = ({ item }) => {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const itemColor = useMemo(() => HexToHueConverter(customization?.itemColor), [customization?.itemColor]);
  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          flex: 1,
        }}
      >
        <div
          style={{
            display: 'flex',
            gap: 10,
            margin: staticValues[15],
            padding: staticValues[10],
            alignItems: 'center',
            borderRadius: 5,
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
            backgroundColor: 'var(--thirdThemeColor)',
          }}
        >
          <div>
            <img
              width={30}
              height={30}
              src="https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504616_0086c4a0-6960-4436-993e-1333b27fa89a.png"
            />
          </div>
          <div>
            <div
              style={{
                textAlign: 'start',
                fontWeight: 700,
                color: 'var(--fourthThemeColor)',
                fontSize: staticValues[14],
              }}
            >
              Address Name
            </div>
            <div style={{ textAlign: 'start', color: 'var(--fourthThemeColor)', fontSize: staticValues[12] }}>
              Address Detail, Apartmen
            </div>
            <div style={{ color: 'var(--fourthThemeColor)', textAlign: 'start', fontSize: staticValues[12] }}>
              Adalar / Istanbul / Türkiye
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            gap: 10,
            margin: staticValues[15],
            padding: staticValues[10],
            alignItems: 'center',
            borderRadius: 5,
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
            backgroundColor: 'var(--thirdThemeColor)',
          }}
        >
          <div>
            <img
              width={30}
              height={30}
              src="https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504616_0086c4a0-6960-4436-993e-1333b27fa89a.png"
            />
          </div>
          <div>
            <div
              style={{
                textAlign: 'start',
                fontWeight: 700,
                color: 'var(--fourthThemeColor)',
                fontSize: staticValues[14],
              }}
            >
              Address Name
            </div>
            <div style={{ textAlign: 'start', color: 'var(--fourthThemeColor)', fontSize: staticValues[12] }}>
              Address Detail, Apartmen
            </div>
            <div style={{ color: 'var(--fourthThemeColor)', textAlign: 'start', fontSize: staticValues[12] }}>
              Adalar / Istanbul / Türkiye
            </div>
          </div>
        </div>
        <div
          style={{
            display: 'flex',
            gap: 10,
            margin: staticValues[15],
            padding: staticValues[10],
            alignItems: 'center',
            borderRadius: 5,
            boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.25)',
            backgroundColor: 'var(--thirdThemeColor)',
          }}
        >
          <div>
            <img
              width={30}
              height={30}
              src="https://d9aff4nz0lkg0.cloudfront.net/icon/png/1710504616_0086c4a0-6960-4436-993e-1333b27fa89a.png"
            />
          </div>
          <div>
            <div
              style={{
                textAlign: 'start',
                fontWeight: 700,
                color: 'var(--fourthThemeColor)',
                fontSize: staticValues[14],
              }}
            >
              Address Name
            </div>
            <div style={{ textAlign: 'start', color: 'var(--fourthThemeColor)', fontSize: staticValues[12] }}>
              Address Detail, Apartmen
            </div>
            <div style={{ color: 'var(--fourthThemeColor)', textAlign: 'start', fontSize: staticValues[12] }}>
              Adalar / Istanbul / Türkiye
            </div>
          </div>
        </div>
      </div>
      <div
        style={{
          backgroundColor: 'var(--thirdThemeColor)',
          color: 'var(--fourthThemeColor)',
          borderRadius: 10,
          fontWeight: 600,
          padding: staticValues[10],
          fontSize: staticValues[12],
          marginTop: 'auto',
          marginBottom: staticValues[20],
          marginLeft: staticValues[20],
          marginRight: staticValues[20],
        }}
      >
        Add Address
      </div>
    </div>
  );
};

export default ProfileAddress_1;
